import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import moment from 'moment'

import Spinner from '@components/spinner'

class Notifications extends Component {
  static propTypes = {
    notificationStore: PropTypes.object,
    handleOutsideClick: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.loadNotifications()
  }

  loadNotifications () {
    this.props.notificationStore.getDropdownNotifications()
  }

  handleNotificationClick = notification => {
    this.props.notificationStore.update(notification, 'followed')
    this.props.handleOutsideClick()
  }

  handleSeeAllClick = () => {
    this.props.handleOutsideClick()
    const { notificationStore } = this.props
    notificationStore.notificationList.replace([])
    notificationStore.getNotificationList()
  }

  renderNotifications = () => {
    const { notificationStore } = this.props
    if (notificationStore.notifications.length < 1) {
      return (
        <div className='empty-message'>
          You don’t have any notifications yet
        </div>
      )
    }
    return notificationStore.notifications.map(notification => {
      return (
        <>
          {notification.link.match('https') ? (
            <a key={notification.id} target="_blank" href={notification.link}>
              <NotificationMessage notification={notification} onClick={this.handleNotificationClick} />
            </a>
          ) : (
            <Link key={notification.id} to={notification.link}>
              <NotificationMessage notification={notification} onClick={this.handleNotificationClick} />
            </Link>
          )}
        </>
      )
    })
  }

  render () {
    const { loading } = this.props.notificationStore
    if (loading) return <Spinner />
    return (
      <div>
        <h3>Notifications</h3>
        <div className='notification-dropdown__list'>
          {this.renderNotifications()}
        </div>
        <div className='notification-dropdown__footer'>
          <Link to='/notification-list'>
            <div
              className='button button--secondary'
              onClick={this.handleSeeAllClick}
            >
              See all
            </div>
          </Link>
          <Link to='/settings'>
            <div
              className='button button--secondary'
              onClick={() => this.props.handleOutsideClick()}
            >
              Settings
            </div>
          </Link>
        </div>
      </div>
    )
  }
}

const NotificationMessage = ({ notification, onClick }) => {
  return (
    <div
      className='notification-dropdown__list__notification'
      onClick={() => onClick(notification)}
    >
      <div
        className={`notification-message ${notification.status !== 'followed' ? 'unread' : ''
          }`}
        dangerouslySetInnerHTML={{ __html: notification.message }}
      />
      <span>
        {moment(notification.createdAt).format('MMM DD YYYY | HH:mm')}
      </span>
    </div>
  )
}

export default inject('notificationStore')(observer(Notifications))
